// extracted by mini-css-extract-plugin
module.exports = {"bannerCoverCard":"banner-cover-card_bannerCoverCard__t1uDX","coverImage":"banner-cover-card_coverImage__1uiB-","description":"banner-cover-card_description__2dDVF"};